import React from 'react'
import {
  Button,
  ModalActions,
  ModalContent,
  ModalHeader,
  Text,
  Icon,
} from '@lightspeed/design-system-react'
import { T } from '@transifex/react'

interface Props {
  onClose: () => void
}

export const ServerError = (props: Props) => {
  const { onClose } = props

  return (
    <>
      <ModalHeader>
        <Icon
          icon="fa-exclamation-triangle"
          className="gift-cards-exclamation-icon vd-pr1"
        />
        <T
          _str="Unable to use gift cards"
          _context="Gift card modal, server error, header"
        />
      </ModalHeader>
      <ModalContent>
        <Text tag="p">
          <T
            _str="Gift cards are unavailable at the moment. Try again later."
            _context="Gift card modal, server error, content"
          />
        </Text>
      </ModalContent>
      <ModalActions>
        <div className="vd-btn-group">
          <Button variant="supplementary" onClick={onClose}>
            <T
              _str="OK, got it"
              _context="Gift card modal, server error, ok button"
            />
          </Button>
        </div>
      </ModalActions>
    </>
  )
}
